<template>
    <!-- Begin Hero Area -->
    <div class="hero-area hero-bg hero-style-3 overflow-hidden" data-bg-image="" :style="{backgroundImage: `url(${ bgImage })`}">
        <div class="container hero-container">
            <div class="hero-item">
                <div class="hero-content white-text">
                    <h1 class="title">Suoriudu vastuullisuusraportoinnista suhauksessa</h1>
                    <p class="desc">Luo vastuullisuusraportti alle 5 minuutissa - toista vain kerran vuodessa!</p>
                    <div class="btn-wrap">
                        <button class="btn btn-custom-size btn-lg blackcurrant-color extbot-primary-hover" @click="test">Luo raportti</button>
                        <a class="extbot-link" @click="scrollBelow">Lue lisää <i class="icofont-long-arrow-right"></i></a>
                    </div>
                </div>
                <div class="hero-img" style="width: 40vw; height: 25vw;">
                    <!-- <div class="single-img">
                        <img src="images/hero/inner-img/3-1-425x915.png" alt="Hero Image">
                    </div>
                    <div class="single-img">
                        <img src="images/hero/inner-img/3-2-425x915.png" alt="Hero Image">
                    </div> -->
                </div>
            </div>
        </div>
    </div>
    <!-- Hero Area End Here -->
</template>
<script>
export default {
  data () {
    return {
      bgImage: 'images/hero/bg/3-1-1920x980.png'
    }
  },
  methods: {
    scrollBelow() {
        document.getElementById("more-info-section").scrollIntoView({behavior: 'smooth', block: 'center'})
    },
    test() {
        this.$emit('toggle-chat')
    }
  },
}
</script>

<style>
    a {
        cursor: pointer;
    }
</style>
